module.exports = __webpack_public_path__ + "img/37_113.3755ce34.png";